export default "__VITE_ASSET__DZWoZBLm__"